import React, { Fragment } from 'react';
import { Container, Button } from 'react-bootstrap';
import Header from '../../components/header';
import Head from '../../components/head';
import Footer from '../../components/footer';
import ListLocais from '../../components/locais/educacao';


function ListEducacaoScreen() {
    return (
        <Fragment>
            <Head titulo="Escolas e Unidades de Educação em Macuco" />
            <Header />
            <Container>
               <ListLocais /><br/><br/>
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ListEducacaoScreen;